import moment from 'moment'
import { useEffect, useState } from 'react'
import useTranslate from '../hooks/useTranslate'

export function basicArrayRenderer(value) {
  return {
    id: value,
    title: value,
  }
}

export default function BasicDateRenderer(value) {
  return value && moment(value).locale('ru').format('LLL')
}
